import { __assign, __rest } from "tslib";
/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon } from "../../icon";
import { SvgCheckFilled as CheckFilledMedium } from "./medium/CheckFilled";
var sizeMap = {
    medium: CheckFilledMedium
};
var defaultSize = getDefaultSize(sizeMap);
export var CheckFilledIcon = forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? defaultSize : _b, rest = __rest(_a, ["size"]);
    return (React.createElement(Icon, __assign({ ref: ref, svgComponent: getSvgResourceForSize(sizeMap, size), size: size }, rest)));
});
CheckFilledIcon.displayName = "CheckFilledIcon";
//# sourceMappingURL=CheckFilledIcon.js.map